import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import type { SyntheticEvent } from "react";
import { useState } from "react";
import ConnectionManagement from "./connection-management/ConnectionManagement";
import Logs from "./logs/Logs";

type Tabs = "connection_management" | "logs";

interface Props {
  hideConnectionManagement?: boolean;
  excludeLogsColumns?: string[];
}

const CrmManagement = ({ hideConnectionManagement, excludeLogsColumns }: Props) => {
  const [selectedTab, setSelectedTab] = useState<Tabs>(hideConnectionManagement ? "logs" : "connection_management");

  const handleTabChange = (_: SyntheticEvent, value: Tabs) => setSelectedTab(value);

  return (
    <Box>
      <TabContext value={selectedTab}>
        <TabList onChange={handleTabChange}>
          {!hideConnectionManagement && <Tab label="Connection Management" value="connection_management" />}
          <Tab label="Logs" value="logs" />
        </TabList>

        {!hideConnectionManagement && (
          <TabPanel value="connection_management">
            <ConnectionManagement />
          </TabPanel>
        )}
        <TabPanel value="logs">
          <Logs excludeColumns={excludeLogsColumns ?? []} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default CrmManagement;
